module.exports = __webpack_public_path__ + "img/dealer-customer-login.57fbaebf.png";